import React, { useState ,useEffect, useContext} from 'react';
import SearchDropDown from '../SearchDropDown/SearchDropDown';
import axios from 'axios';
import './MapFilter.css';
import _ from 'lodash';
import {AppContext} from '../../Context';
import {Mapfilter_url} from '../../Essentials/variables'
import VectorLayer from 'ol/layer/Vector';
import { getAccessibleState } from '../../Essentials/common_fn';
import { BaseURL } from '../../Essentials/variables';
import { Stroke, Style } from "ol/style";
import {Feature} from 'ol/Feature'
import Icon from "ol/style/Icon";
import { ENV_URL } from '../../Essentials/variables';
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
export default function MapFilter(){
    
    const [allOptions,setAllOptions] = useState([]);
    const [allState,setAllState] = useState([]);
    const [state,setState] = useState([]);
    const [district,setDistrict] = useState([]);
    const [tehsil,setTehsil] = useState([]);
    const [village,setVillage] = useState([]);    
    const [selected, setSelected] = useState({'State':'','District':'','Sub_District':'','Village':''});
    const [selectionCount,setSelectionCount] = useState(0);
    const [dealerGeoData, setDealerGeoData] = useState(null);
    const {dealerPoi, setDealerPoi,options,setOptions } = useContext(AppContext);
    const [submitCount,setSubmitCount] = useState(0);
    const { stateData, setStateData } = useContext(AppContext);

    // let Token=localStorage.getItem('token')
//////new code////////////////////////
function getGeoJsonObjBuildWarpper(lat, long, propertiesParam) {
    let latlongArray = [long, lat];
    return {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: latlongArray,
        },
        properties: propertiesParam,
    };
}
    let url='';
    function getDealerData(state, districtParam, subDistrictParam) {
        if (districtParam == null || districtParam == "") {
            // console.log("District toh null hai");
            url = `${BaseURL}emr/${state}/all`;
        } else if (subDistrictParam == null || subDistrictParam == "") {
            // console.log("SubDistrict toh null hai");
            url = `${BaseURL}emr/${state}/${districtParam}/all`;
        } else {
            // console.log("Yahi khul raha");
            url = `${BaseURL}emr/${state}/${districtParam}/${subDistrictParam}/all`;
        }
        fetch(url,{
            headers: {
                'x-access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
              },
        })
            .then((res) => res.json())
            .then((ResData) => {
                let features = [];
                ResData?.forEach((data) => {
                    console.log("check data",data);
                    features.push(
                        getGeoJsonObjBuildWarpper(
                            data.latitude,
                            data.longitude,
                            data
                        )
                    );
                });
                // console.log(features);
                // console.log(features?.properties);
                // console.log(features.properties.outlet_type);
                let vs = new VectorSource({
                    features: new GeoJSON().readFeatures({
                        type: "FeatureCollection",
                        features: features,
                    }),
                });

 

                let stylefn = (feature) => {
                  
                    console.log("features in stylefn",feature?.values_?.channel);
                    // console.log("feature.values_",feature?.values_);
                    // console.log("Outlet type",feature?.values_?.outlet_type);
                    let imageSrc='',imgColor='';
                    if(feature?.values_?.channel=='NEXA'){
                        // console.log('O type show N')
                        imgColor='#000000'
                        imageSrc='/data/new/nexa.svg'
                    }
                    else if(feature?.values_?.channel=='MAIN OUTLET'){
                        imageSrc='/data/new/arenao.svg'
                        imgColor='#3E54AC'
                    }
                    else if(feature?.values_?.channel=='E OUTLET'){
                        console.log('E-NRM type show E Important')
                        imageSrc='/data/new/arenae.svg'
                        imgColor='#3E54AC';
                    }
                    else if(feature?.values_?.channel=='R OUTLET'){
                        // console.log('R-NRM type show R')
                        imageSrc='/data/new/arenar.svg'
                        imgColor='#3E54AC';
                    }
                    else {
                        // console.log('R-NRM type show R')
                        imageSrc='/data/new/mssip.svg'
                        imgColor='#3E54AC';
                    }
                    console.log("img src",imageSrc,"--",imgColor);
                    // else if(feature?.values_?.channel==='MSSSP'){
                    //     // console.log('R-NRM type show R')
                    //     imageSrc='/data/new/mssip.svg'
                    //     imgColor='#3E54AC';
                    // }
                    
                    // if((feature?.values_?.outlet_type==='Outlet' || feature?.values_?.outlet_type==='O') && feature?.values_?.channel==='EXC'){
                    //     // console.log('O type show N')
                    //     imgColor='#000000'
                    //     imageSrc='/data/new/nexa.svg'
                    // }
                    // else if((feature?.values_?.outlet_type==='Outlet' || feature?.values_?.outlet_type==='O') && feature?.values_?.channel==='NRM'){
                    //     imageSrc='/data/new/arenao.svg'
                    //     imgColor='#3E54AC'
                    // }
                    // else if((feature?.values_?.outlet_type==='E-Outlet' || feature?.values_?.outlet_type==='E') && feature?.values_?.channel==='NRM'){
                    //     console.log('E-NRM type show E Important')
                    //     imageSrc='/data/new/arenae.svg'
                    //     imgColor='#3E54AC';
                    // }
                    // else if((feature?.values_?.outlet_type==='R-Outlet' || feature?.values_?.outlet_type==='R') && feature?.values_?.channel==='NRM'){
                    //     // console.log('R-NRM type show R')
                    //     imageSrc='/data/new/arenar.svg'
                    //     imgColor='#3E54AC';
                    // }
                    // console.log(features[0].properties);
                    // console.log("one");
                    return new Style({
                        image: new Icon({
                            anchor: [0.5, 46],
                            anchorXUnits: "fraction",
                            anchorYUnits: "pixels",
                            src: imageSrc,
                            color: imgColor,
                            scale: 1,
                        }),
                    });
                };
                let vctLyr = new VectorLayer({
                    source: vs,
                    style: stylefn,
                });
                vctLyr.set("name", "dealerDisplay");
                
                //console.log(vctLyr);
                setDealerGeoData(vctLyr);
                //return vctLyr;
            });
    }
//////////////////////new data/////////////////////////////
useEffect(()=>{
    fetch('state-name.json').then(res => res.json()).then(data => {
        //setAllState(data["states"].filter((state)=>{return JSON.parse(localStorage.getItem('accessible_state')).includes(state) || JSON.parse(localStorage.getItem('accessible_state')) === 'ALL'}));
        setAllState(data["states"].filter((state)=>{return getAccessibleState(stateData?.optionSelection)?.includes(state) || getAccessibleState(stateData?.optionSelection) === 'ALL'}));
    }); 
    // console.log(stateData.optionSelection);
},[stateData.optionSelection]);

function displayNoneOptionsfn(){
    fetch('state-name.json').then(res => res.json()).then(data => {
        //setAllState(data["states"].filter((state)=>{return JSON.parse(localStorage.getItem('accessible_state')).includes(state) || JSON.parse(localStorage.getItem('accessible_state')) === 'ALL'}));
        setAllState(data["states"].filter((state)=>{return getAccessibleState(stateData?.optionSelection)?.includes(state) || getAccessibleState(stateData?.optionSelection) === 'ALL'}));
    }); 
}
//////////////Adding new codes////////////////////////////////////////////6/5/2023/////
function removeDealerVectorLayer(map) {
    try {
        // console.log("Kaushik don-..",map);
        map?.getLayers()?.forEach((lyr) => {
                    console.log(lyr);
                    if (lyr?.get("name") == "dealerDisplay") {
                        map.removeLayer(lyr);
                    }
                });
            
    } catch (error) {
        console.log(error)
    }
}

useEffect(() => {
    // console.log(stateData);
    removeDealerVectorLayer(stateData?.mapObject);
    
}, [
    stateData?.selected?.State,
    stateData?.selected?.District,
    stateData?.selected?.Sub_District,
]);
useEffect(() => {
    if (dealerGeoData != null) {
        stateData?.mapObject.addLayer(dealerGeoData);
    }
}, [dealerGeoData]);

useEffect(() => {
    // console.log('remove dealer layer triggered')
    removeDealerVectorLayer(stateData?.mapObject);
    if (
        stateData?.selected?.State != null &&
        stateData?.selected?.District != null &&
        (dealerPoi)
    ) {
        getDealerData(
            stateData?.selected?.State,
            stateData?.selected?.District,
            stateData?.selected?.Sub_District
        );
    }
    // if (cusFinSelector !== "dealer") {
    //     setDealerGeoData(null);
    // }
    if (!dealerPoi) {
        setDealerGeoData(null);
    }
}, [ dealerPoi]);

///////////////////////////////////////////////////////////////////////////////////////

useEffect(()=>{
    // if(selected.State === '' && selected.District === '' && selected.Sub_District === '' && selected.Village === '')
    //             displayNoneOptionsfn();
    if(!_.isEmpty(stateData?.mapObject)){
        stateData?.mapObject?.getAllLayers()?.forEach((layer)=>{
            if(layer instanceof VectorLayer && !layer?.getSource()?.getUrl()?.includes('getboundary')){
                stateData?.mapObject?.removeLayer(layer);
            }
        });
        if(_.isEmpty(stateData.selected.Sub_District)){
            if(!_.isEmpty(stateData.mapObject)){
                stateData?.mapObject?.getAllLayers()?.forEach((layer)=>{
                    if(layer instanceof VectorLayer && layer.getSource()?.getUrl()?.includes('heatmap')){
                        stateData?.mapObject?.removeLayer(layer);
                    }
                });
            }
        }
    }
    setSelectionCount(selectionCount+1);
        //console.log(stateData.mapObject.getLayers());
},[stateData.selected]);
   function getDistrict(state){  
    if(!_.isEmpty(state)){
        // setOptions({...options,'zo':["Nik"],'ro':["Region nik"]});
        
        fetch(Mapfilter_url + '/' + _.replace(state,/ /g, '')).then(data => data.json()).then(data => {
            const allOptions = data.map(item => {
                return {
                    state: item.STATE_NAME,
                    district: _.replace(item.DISTRICT_NAME," District",""),
                    tehsil: item.TEHSIL_DESC,
                    village: item.VILLAGE_NAME
                }
            });
            setAllOptions(allOptions);
            return allOptions;
        }).then((allOptions) => {
            
            let district_obj = _.uniq(allOptions.filter(item => item?.state === state).map(item => item?.district));
            //console.log(district);
            district_obj.sort();
            setDistrict(district_obj);
            // console.log("District Output->",district_obj)
        });
        let Token=localStorage.getItem('token');
        console.log("Hit to get zone region");
        axios({
            method: 'GET',
            headers: {
              "x-access-token": Token,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Frame-Options': 'DENY',
              'Content-Security-Policy': "frame-ancestors 'none'",
              'Feature-Policy': "frame-ancestors 'none'"
            },
            withCredentials: true,
            url: ENV_URL+"api/getzoneregion/"+state
          }).then((res) => {
            console.log(res?.data?.Zone)
           //  console.log(res?.data?.message)
           setOptions({...options,'zo':res?.data?.Zone,'ro':res?.data?.Region});
          })
          .catch((err)=>{
            console.log(err);
          })
    }
            
    }    

    function getTehsil(district){
        let tehsil_obj = _.uniq(allOptions.filter(item => item?.district === district).map(item => item?.tehsil))
        //console.log('getTehsil',district,tehsil_obj);
        setTehsil(tehsil_obj.sort());

    }
    function getVillage(tehsil){
        let village = _.uniq(allOptions.filter(item => item?.tehsil === tehsil).map(item => item?.village))
        //console.log('getvillage',tehsil,village);
        setVillage(village.sort());
    }

    function selection(type,value){
        // console.log('selection',type,value);
        //console.log(type,value);
        if(type === 'State'){
            // console.log('case state');
            setState(stateData?.selected.State);
            setSelected({'State':value,'District':'','Sub_District':'','Village':''})
            
            getDistrict(value)

            // console.log(district);
            
        }else if(type === 'District'){
            // console.log('case district');
            if (value) {
              setSelected({...selected, District:value, Sub_District:'', Village:''});
              getTehsil(value);
            } else {
              setSelected({...selected, District:'', Sub_District:'', Village:''});
            }
        } else if (type === 'Sub-District') {
          // console.log('case sub-district');
          if (value) {
            setSelected({ ...selected, Sub_District: value, Village: '' });
            getVillage(value);
          } else {
            setSelected({ ...selected, Sub_District: '', Village: '' });
          }
        } else if (type === 'Village') {
        //    console.log('case village',value);
          if (value) {
            setSelected({ ...selected, Village: value });
          } else {
            setSelected({ ...selected, Village: '' });
          }
        }
    }

    

    return(
        <div className="map-filter">
            {/* {console.log('dropdownparams"-',district,tehsil,village)}  */}
            <div className='map-filter-input'><SearchDropDown placeholder={"State"} options={allState} selection={selection} dblclkselection={stateData.selected.State} /></div>
            <div className='map-filter-input'><SearchDropDown placeholder={"District"} options={district} selection={selection} dblclkselection={stateData.selected.District} /></div>
            <div className='map-filter-input'><SearchDropDown placeholder={"Sub-District"} options={tehsil} selection={selection} dblclkselection={stateData.selected.Sub_District} /></div>
            <div className='map-filter-input'><SearchDropDown placeholder={"Village"} options={village} selection={selection} dblclkselection={stateData.selected.Village} /></div>
            <div className='submit-btn-div'>
                <button className="submit-btn" onClick={() => {
                    setStateData({ ...stateData, selected });
                    setSubmitCount(submitCount + 1);
                    // console.log("Test State", selected.State);
                    if(selected.State === undefined){ console.log("Test State", selected.State); window.location.reload(true); }
                }}
                
                 disabled={selected.State === '' && selected.District === '' && selected.Sub_District === '' && selected.Village === '' || selectionCount <= submitCount}
                 >
                    Submit
                    </button>
            </div>
        </div>
    );
}